import { render } from "./acountAdjust.vue?vue&type=template&id=5e2e80fe&scoped=true"
import script from "./acountAdjust.vue?vue&type=script&lang=js"
export * from "./acountAdjust.vue?vue&type=script&lang=js"

import "./acountAdjust.vue?vue&type=style&index=0&id=5e2e80fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2e80fe"]])

export default __exports__